import { useEffect } from "react";

export function usePrefillForm(
  dataFromFileUploads,
  questionToFieldMap,
  formValuesOrSetters,
  setFormValues, // optional, only used in "single state object" case
  dropdownConfigs = {}
) {
  useEffect(() => {
    if (!Array.isArray(dataFromFileUploads) || dataFromFileUploads.length === 0)
      return;

    // --- CASE 1: Single state object ---
    if (setFormValues) {
      const updatedValues = { ...formValuesOrSetters };

      dataFromFileUploads.forEach((item) => {
        const fieldKey = questionToFieldMap[item.question];
        if (fieldKey) {
          //  Only prefill if the field is empty (so the user can still change later)
          if (!updatedValues[fieldKey]) {
            updatedValues[fieldKey] = item.keywords;
          }

          //  Add missing dropdown options if needed
          if (dropdownConfigs[fieldKey]) {
            const { options, setOptions } = dropdownConfigs[fieldKey];
            if (!options.includes(item.keywords)) {
              setOptions([...options, item.keywords]);
            }
          }
        }
      });

      setFormValues(updatedValues);
    }

    // --- CASE 2: Individual states (separate useStates) ---
    else {
      dataFromFileUploads.forEach((item) => {
        const fieldKey = questionToFieldMap[item.question];
        if (fieldKey && formValuesOrSetters[fieldKey]) {
          //  Only set default if value is empty
          formValuesOrSetters[fieldKey]((prev) => prev || item.keywords);

          //  Add missing dropdown options if needed
          if (dropdownConfigs[fieldKey]) {
            const { options, setOptions } = dropdownConfigs[fieldKey];
            if (!options.includes(item.keywords)) {
              setOptions([...options, item.keywords]);
            }
          }
        }
      });
    }
  }, [dataFromFileUploads]);
}
